import { render, staticRenderFns } from "./careerPlanning.vue?vue&type=template&id=4ba14c12&scoped=true"
import script from "./careerPlanning.vue?vue&type=script&lang=js"
export * from "./careerPlanning.vue?vue&type=script&lang=js"
import style0 from "./careerPlanning.vue?vue&type=style&index=0&id=4ba14c12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_71321242e37ff7a0c7584d931db29eba/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba14c12",
  null
  
)

export default component.exports